module.exports = __webpack_public_path__ + "static/img/coupon-off.d916c6aa.png";